import { NavLink, useNavigate } from "react-router-dom";
import { Button } from "../../components/Button";
import { STATUS_COLOR } from "../../utils/constants";
import { IconMessage, IconNextList, IconPrevList, IconSearch, IconView } from "../Icons";
import "./style.css";
import { useState } from "react";


export const ListWrapper = (props) => {
  return (
    <div className="list-wrapper" style={props?.style}>
      {props?.title && <div className="list-title">{props?.title}</div>}
      {props.children}
    </div>
  );
};

export const ListFilterButtons=(props)=>{

  const handleCheck = (event) => {
    const value = event.target.value;
    if (event.target.checked) {
      props.handleChange(props?.name, [...props?.selected, value]);
    } else {
      props.handleChange(props?.name, props?.selected?.filter((v) => v !== value));
    }
  };
  return <div className="list-filter-buttons" style={props?.style}>
  {
      props?.list?.map(sta=>{
          return <div key={sta?.value} className="lfb-button" style={{
            background:sta?.bgColor || '#f1f1f1',
            color:sta?.textColor || 'gray',
            borderColor:sta?.textColor || 'gray'
          }}>
            <input type='checkbox' checked={props?.selected.includes(sta?.value)} value={sta?.value} onChange={handleCheck}/> {sta?.title}
            </div>
      })
  }
</div>
}

export const ListFilter = ({children}) => {
  
  return<div className="list-filters">
    {children}
  </div>
}

export const FilterInput = (props) => {

  return<div className="list-filter-input">
    {props?.label && <label className="list-filter-input-label">{props?.label}: </label>}
    <input 
      name={props?.name}
      value={props?.value}
      placeholder={props?.hint}
      onChange={(e)=> props?.handleChange(props?.name, e?.target?.value)}
    />
  </div>
}

export const FilterDropdown = (props) => {

  return<div className="list-filter-dropdown">
      {props?.label && <label className="list-filter-dropdown-label">{props?.label}: </label>}
  {/* <div className="list-filter-dropdown-inner-div"> */}
      <select className="list-filter-dropdown-select" id={props.id}
          onChange={(e) => props.handleChange(props.name, e?.target?.value, props?.options?.list.find(itm=>itm[props?.options?.value]===e?.target?.value))}
          value={props?.selected}
      >
          <option value="0">--Select--</option>

          {props?.options?.list?.map((itm,index) => {
              return <option id={index} key={index} value={itm[props?.options?.value]}>{itm[props?.options?.name]}</option>
          })}
      </select>
  {/* </div> */}
</div>
}

export const List = (props) => {
  const navigate = useNavigate();
  // const [payload, setPayload] = useState({});

  const handleSearch = (event) => {
    const value = event.target.value;
    props?.handleChange(value);

    console.log(value);
  }

  return (
    <>
      <div className="list-div">
        <div className="list-header-div">
          
          {props?.search && <div className="search-div">
            <input 
              name="searchInput"
              value={props?.searchValue}
              placeholder="Search..."
              onChange={handleSearch}
            />
            <p><IconSearch /></p>
          </div>}

          {props?.actionBtnTitle && (<div className="list-action-btn">
            <Button
              varient="action-btn"
              bgColor="primary"
              title={props?.actionBtnTitle}
              onClick={() => navigate(props?.href)}
            />
          </div>
            
          )}
        </div>
        <table className="list-table">
          <Thead headers={props?.thead} />
          {props?.children}
        </table>
      </div>

      {/* 
        <div className='list-footer'>
            <div className='list-footer-inner-div'>
                <div className='pagination-goto-div'>
                    <p>Go to page</p>
                    <input 
                        value={payload?.goto}
                        onChange={(e)=>handleChange('goto', e.target.value)}
                    />
                    <button >GO</button>
                </div>

                <ul className="paggination-btn-div">
                    <li><IconPrevList onClick={()=>alert("next")}/></li>
                    <li><NavLink to="">1</NavLink></li>
                    <li><NavLink to="">2</NavLink></li>
                    <li><NavLink to="">3</NavLink></li>
                    <li><NavLink to="">4</NavLink></li>
                    <li><NavLink to="">5</NavLink></li>
                    <li><IconNextList onClick={()=>alert("prev")}/></li>
                </ul>

                <div className='pagination-view-div'>
                    <p>Items per page</p>
                    <select 
                        value={payload?.itemsPerPage}
                        onChange={(e) => handleChange('itemPerPage', e?.target?.value)}
                    >
                        <option>10</option>
                        <option>50</option>
                        <option>100</option>
                    </select>
                    
                </div>
            </div>
            

            
        </div> */}
    </>
  );
};

const Thead = ({ headers }) => {
  return (
    <thead>
      <tr className="list-header">
        {headers?.map((head, index) => {
          return (
            <td key={index} style={{ width: head?.width }}>
              {head?.title}
            </td>
          );
        })}
      </tr>
    </thead>
  );
};

export const ListBody = (props) => {
  return (
    <>
      <tbody>{props?.children}</tbody>
    </>
  );
};

export const TaxReturnStatus = ({ status, code }) => {
  return (
    <span
      className="tax-file-status"
      style={{
        background: STATUS_COLOR?.[code]?.bgColor,
        color: STATUS_COLOR?.[code]?.color,
      }}
    >
      {status}
    </span>
  );
};

export const ListRowActions = ({ children, actions = [] }) => {
  return (
    <div style={{display:'flex',columnGap:'12px',alignItems:'center'}}>
      {actions.map((action) => {
        switch (action.icon) {
          case "view":
            return <IconView size={action.size || '22px'} onClick={action.onClick} />;
          case "message":
            return <IconMessage size={action.size || '18px'} onClick={action.onClick} />;
        }
      })}
    </div>
  );
};
